import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { adminMail } from '../../../constants';

const ContactInfo = (): React.ReactElement => {
  const { t } = useTranslation();
  const listStyle: CSSProperties = {
    margin: 0,
    listStyleType: 'none',
    textAlign: 'right',
  };

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedTab);
  // }, [selectedTab]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ul style={listStyle}>
      <li>
        {t('helpCenter.contact.office')}：<a href={'mailto:' + adminMail}>{adminMail}</a>
      </li>
      <li>{t('helpCenter.contact.hours')}</li>
    </ul>
  );
};

export default ContactInfo;
